export default {
	head: {
		title: 'Blumar - Congresos y Eventos',
		description: 'Blumar Congresos y Eventos es la agencia oficial del evento 76º Congresso da SBD - dermatologia_2023. Encuentra las mejores ofertas de alojamiento y pasajes aéreos. Más de 30 años de experiencia en lo mercado corporativo de eventos.',
		keywords: 'Congresos, Conferencias, eventos, 76º Congresso da SBD, dermatologia_2023, agencia oficial, albergues, hoteles, Centro de Convenções Centrosul, pasajes aéreos, comparación de precios, tours, traslados.',
		ogDescription: 'Blumar Congresos y Eventos es la agencia oficial del evento  - . Encuentra las mejores ofertas de alojamiento y pasajes aéreos. Más de 30 años de experiencia en lo mercado corporativo de eventos',
	},
	globalErrors: {
		serviceUnavailable: 'No fue posible acceder al servicio. Inténtelo nuevamente en unos instantes.',
		serverErrorTitle: 'Algo no salió como se esperaba',
		backToSite: 'Volver a la página de inicio',
		loadFailed: 'No fue posible cargar esta página.',
		tryAgain: 'Intentar nuevamente',
	},
	header: {
		subtitle: "Congresos, Convenciones y Eventos en todo Brasil",
	},
	navbar: {
		companyProfile: "Presentación",
		calendar: "Calendario",
		accommodation: "Hospedaje",
		flightBookings: "Pasaje Aéreo",
		transportation: "Transporte",
		preAndPostTours: "Pre & Post Tours",
		localTours: "Tours Locales",
		resume: "Currículo",
		clientsArea: "Zona de clientes",
		exit: 'Salir'
	},
	languageDropdown: {
		languages: {
			Pt: 'Português',
			En: 'English',
			Sp: 'Español',
		},
	},
	loginArea: {
		user: 'Login',
		pass: 'Contraseña',
		enter: 'Entrar',
		error: {
			title: '¡Error!',
			message: 'El nombre de usuario o la contraseña no son válidos'
		}
	},
	home: {
		aboveEventCalendarText: "Seleccione un evento a continuación para obtener más información sobre hoteles, tours, boletos aéreos, políticas de cancelación y más.",
		asideYearsTabText: "Seleccione el año y vea los eventos ya confirmados:",
		confirmedEvents: {
			title: "Eventos ya confirmados",
			loading: "Cargando eventos...",
			empty: "No hay eventos confirmados para este período.",
			reviewsLabel: "Evaluaciones Trustindex",
		},
		hero: {
			videoTitle: "Video de fondo",
			headline: {
				strongStart: "Compromiso real",
				middle: " en cada etapa",
				endStart: "de la ",
				strongEnd: "planificación a la entrega",
			},
		},
	},
	footer: {
		ourContacts: "Nuestros contactos",
		contactLabel: "contactenos",
		socialLabel: "redes sociales",
		portfolioLabel: "Portafolio",
		address: "Blumar Brasil - Rua Siqueira Campos 43 - cob 2 - CEP: 22031-901 - Copacabana - Rio de Janeiro - Brasil - Tel: 21 2142-9300",
		privacyPolicy: "Política de Privacidad",
	},
	cookieConsent: {
		message: '',
		acceptButton: '',
		privacyPolicy:'',
	},
	eventCard: {
		betweenDatesText: 'a',
		actionLabel: 'más sobre este evento',
		pastLabel: 'evento realizado',
	},
	eventHeader: {
		officialAgency: 'SOMOS LA AGENCIA OFICIAL DEL EVENTO',
	},
	eventPage: {
		periodConnector: 'a',
		optionLabels: {
			hotelReservation: 'Reserva de Hotel',
			flightReservation: 'Reserva Aérea',
			transferReservation: 'Reserva de Transfers',
			localTours: 'Tours Locales',
			aboutBrazil: 'Informaciones Generales de Brasil',
			destinationInfo: 'Informaciones sobre la ciudad',
			eventWebsite: 'Website del Evento',
			visaAndVaccine: 'Visa y Vacuna',
		},
		officialAgency: {
			title: 'Sobre Blumar',
			firstParagraph: eventName => `Blumar Turismo es la agencia oficial de ${eventName} y la única autorizada por la organización del evento para negociar tarifas y realizar bloqueos en su nombre. Otras agencias pueden entrar en contacto ofreciendo hospedaje y pasajes aéreos, sin embargo, tenga en cuenta que esas agencias no tienen autorización para negociar en nombre del evento ni acceso a los bloqueos concedidos para el mismo. Por lo tanto, no hay garantía para el participante en caso de problemas de pago, atención o reserva. Todo el equipo de eventos de Blumar Congressos e Eventos está a disposición para responder solicitudes o informaciones por el teléfono 21 2142 9315 o por email eventos@blumar.com.br. ¡Gracias y buen congreso!`,
			secondParagraph: 'Con más de 30 años de experiencia en el mercado corporativo de eventos, Blumar también ofrece, para su comodidad, servicios de transfers, tours locales y tours pre y post congreso.',
		},
	},
	prePostTours: {
		title: 'Pre & Post Tours',
		book: 'quiero reservar',
		included: 'El paquete incluye:',
		excluded: 'No incluye:',
		form: {
			title: 'Haga su solicitud',
			name: 'Nombre',
			email: 'E-mail',
			departureDate: 'Fecha de salida',
			message: 'Mensaje',
			close: 'cerrar',
			submit: 'enviar solicitud',
			sending: 'Enviando solicitud...',
			success: '¡Solicitud enviada con éxito!',
			failureTitle: 'Solicitud no enviada.',
			failureMessage: 'No fue posible enviar su solicitud. Inténtelo nuevamente más tarde.',
		},
		tours: {
			5: {
				title: 'BUZIOS',
				description: [
					'Hace algunas décadas, Búzios comenzaba a convertirse en un hermoso lugar donde las personas ricas y famosas iban en busca de paz y tranquilidad. En 1960, el interés por el lugar aumentó con la visita de la actriz francesa Brigitte Bardot, entonces una famosa estrella del cine internacional que eligió la ciudad para relajarse durante algunos días. Desde entonces, Búzios pasó a formar parte del itinerario del turismo internacional. Búzios cuenta con una buena infraestructura de hoteles y alojamientos de categoría internacional, además de agradables restaurantes y bares. Actualmente, la Península aún conserva un poco del pueblo pesquero que siempre le dio un toque especial a la ciudad.',
				],
				included: [
					'2 noches en la Pousada Pedra da Laguna',
					'Traslados Aeropuerto de Río de Janeiro x Búzios',
					'Paseo en lancha (6 horas)',
				],
				excluded: ['Pasaje aéreo', 'Cualquier ítem no mencionado anteriormente'],
				price: [
					'A partir de 6 cuotas de R$310,00 por persona en apartamento doble',
					'Total de R$1.860,00 por persona',
				],
				notes: ['Precio a consultar'],
			},
			2: {
				title: 'FOZ DO IGUAZÚ',
				description: [
					'Foz do Iguaçu tiene el privilegio de estar ubicada en la triple frontera entre Brasil, Argentina y Paraguay, y es conocida como la “Ciudad de las Cataratas”, donde los ríos Paraná e Iguaçu forman uno de los paisajes naturales más bellos: las Cataratas del Iguazú, visitadas por gente de todas las partes del mundo.',
					'La ciudad también ofrece atractivos imperdibles, con énfasis en la arquitectura religiosa, como la Iglesia Matriz, el Templo Budista, la Mezquita Musulmana y la Represa de Itaipú, la mayor del mundo en producción de energía.',
				],
				included: [
					'3 noches en el Hotel Grand Carimã',
					'Traslados Aeropuerto de Foz x Hotel',
					'Cataratas Brasileñas',
					'Macuco Safari',
					'Parque de las Aves',
				],
				excluded: ['Pasaje aéreo', 'Cualquier ítem no mencionado anteriormente'],
				price: [
					'A partir de 6 cuotas de R$445,00 por persona en apartamento doble',
					'Total de R$2.670,00 por persona',
				],
				notes: ['Precio a consultar'],
			},
			6: {
				title: 'PARATY',
				description: [
					'Paraty es una encantadora ciudad colonial, reconocida como Patrimonio Histórico y Cultural, que preserva hasta hoy su arquitectura impecable y un entorno natural cautivador. Caminar por su Centro Histórico libre de autos es como viajar en el tiempo, descubriendo calles de piedra, casonas centenarias y relatos del ciclo del oro y del café — períodos en los que Paraty tuvo gran importancia económica y portuaria.',
					'El paquete incluye 3 noches en el Sandi Hotel con desayuno, traslados entre el Aeropuerto de Río de Janeiro y Paraty, además de experiencias completas: un paseo en goleta Netuno Vintage por las aguas tranquilas de la bahía y un City Tour con degustación de cachaça, que revela la cultura y los sabores locales.',
				],
				included: [
					'3 noches en el Sandi Hotel con desayuno',
					'Traslados Aeropuerto de Río de Janeiro x Paraty',
					'Paseo en Goleta Netuno Vintage',
					'City Tour con Degustación de Cachaça',
				],
				excluded: ['Pasaje aéreo', 'Cualquier ítem no mencionado anteriormente'],
				price: [
					'A partir de 6 cuotas de R$556,16 por persona en apartamento doble',
					'Total de R$3.337,00 por persona',
				],
				notes: ['Precio a consultar'],
			},
			68: {
				title: 'Paquete Personalizado: Tu Paquete Ideal',
				description: [
					'¿Quieres un itinerario exclusivo para explorar la ciudad? Ofrecemos un paquete personalizado con las mejores opciones turísticas. Planifica tu viaje con detalles a tu medida y descubre las atracciones más encantadoras con todo el confort y conveniencia.',
				],
			},
			73: {
				title: 'ANAVILHANAS ECO LODGE - AMAZONAS',
				description: [
					'Viva una experiencia inolvidable en la Amazonia. Disfrute 4 días y 3 noches en el exclusivo Anavilhanas Lodge, con comidas, traslados y todas las actividades del hotel incluidas.',
					'No incluye pasaje aéreo ni ítems no mencionados.',
				],
				price: [
					'💰 Valor por persona: R$10.220,00',
					'o 6 cuotas de R$1.703,33',
				],
				notes: ['Precio a consultar'],
			},
			72: {
				title: 'LENÇOIS MARANHENSES - BARREIRINHAS',
				description: [
					'Descubra Barreirinhas, la puerta de entrada a los increíbles Lençóis Maranhenses. Al hospedarse por 4 noches en la encantadora Pousada Encantes do Nordeste, con desayuno incluido, usted disfruta de confort y tranquilidad a orillas del Río Preguiças. El paquete ofrece transporte privado entre el aeropuerto de São Luís y Barreirinhas, garantizando comodidad desde la llegada.',
					'Durante el viaje, explora lo mejor de la región con paseos completos: el Circuito Lagoa Bonita, famoso por sus dunas impresionantes y un atardecer inolvidable; el Circuito Lagunas de Atins (Canto do Atins), con lagunas cristalinas y gastronomía típica; y el Circuito Santo Amaro (Betânia), una de las áreas más preservadas y tranquilas del parque. Al final, el regreso a São Luís también se realiza en transporte privado.',
				],
				included: [
					'4 noches en Barreirinhas en la Pousada Encantes do Nordeste con desayuno',
					'Transporte privado Aeropuerto de São Luís / Barreirinhas',
					'Circuito Lagoa Bonita',
					'Circuito Lagunas de Atins (Canto do Atins)',
					'Circuito Santo Amaro (Betânia)',
					'Transporte privado Barreirinhas / São Luís',
				],
				excluded: ['Pasaje aéreo', 'Cualquier ítem no mencionado anteriormente'],
				price: [
					'A partir de 6 cuotas de R$791,00 por persona en apartamento doble',
					'Total de R$4.746,00 por persona',
				],
				notes: ['Precio a consultar'],
			}
		},
	},
	datepicker: {
		previousDecade: 'Década anterior',
		previousYear: 'Año anterior',
		previousMonth: 'Mes anterior',
		currentMonth: 'Mes actual',
		nextMonth: 'Mes siguiente',
		nextYear: 'Año siguiente',
		nextDecade: 'Década siguiente',
		today: 'Hoy',
		selectedDate: 'Fecha seleccionada',
		noDateSelected: 'Ninguna fecha seleccionada',
		calendar: 'Calendario',
		calendarNavigation: 'Navegación del calendario',
	},
	waitModal: {
		title: 'Blumar',
		message: 'Espere',
		close: 'Cerrar',
	},
	creditCardInfo:{
		title:'Información de pago',
		nameCreditCard:'Nombre (igual de la tarjeta)',
		numberCreditCard:'Número de la tarjeta (solamente números)',
		code:'Código de seguridad',
		codeInfo:'¿Qué es esto?',
		expireDate:'Vencimiento (mes/año)',
		installments:'Número de cuotas',
		receiptData:'Datos para emisión del Recibo Electrónico',
		inscription:'Inscripción',
		inscriptionCPF:'CPF',
		inscriptionCNPJ:'CNPJ',
		state:'Estado',
		uf:'Estado (Sigla)',
		city:'Ciudad',
		district:'Vecindario',
		street: 'Camino',
		number: 'Número',
		complement:'Complementar',
		zipCode:'Código Postal',
		book: {firstTry: 'reservar', retry: 'pagar'}
	},
	hotelReservationCard: {
		checkinDate: 'Fecha de llegada',
		checkoutDate: 'Fecha de salida',
		rooms: 'Cuartos',
		guests: 'Huéspedes',
		perRoom: 'Por habitación',
		adults: 'Adultos',
		children: 'Niñas',
		age: (n) => n === 1 ? `${n} año` : `${n} años`,
		childrenAges: 'Complete las edades de los niños',
		bookHere: 'RESERVE AQUÍ',
		hotelSearch: 'Búsqueda de hoteles',
		hotelSearchObs: 'Tarifas por habitación, por día en Real Brasileño (BRL)',
		continueButton: 'CONTINUE',
		installments: 'Pagamos en',
		installmentsWithoutTax: ' cuotas sin interés.',
		changeReservation: 'Cambiar Reserva',
		sortBy: 'Ordenar por',
		noResultsFound: 'Ningún resultado encontrado.',
		mobileSearch: {
			changeSearch: 'alterar busqueda',
			checkin: 'Llegada',
			checkout: 'Salida',
			double: 'Doble',
			quadruple: 'Cuadruple',
			resultTitle: 'Resultado Busqueda',
			searchTitle: 'Reserva de Hotel',
			single: 'Individual',
			triple: 'Triple',
		},
	},
	hotelBookingPersonalInfo:{
		reservationData: 'Datos da la reserva',
		hotel: 'Hotel',
		room: 'Habitación',
		rooms: 'Habitaciónes',
		roomGuests: 'Huéspedes de la habitación',
		quantity: 'Calidad',
		allocationTypeSGL: 'Individual',
		allocationTypeDBL: 'Doble',
		allocationTypeTPL: 'Triple',
		allocationTypeQPL: 'Quadruplo',
		checkin: 'Fecha de llegada',
		checkout: 'Fecha de salida',
		dailyPrice: 'Diaria',
		breakfast: 'Desayuno',
		breakfastIncluded: 'Desayuno incluido',
		breakfastNotIncluded: 'Desayuno no incluido',
		taxes: 'Taxas',
		total: 'Total',
		fillFields: 'COMPLETE LOS CAMPOS ABAJO',
		paxInfo: 'informaciones del titular de la reserva',
		pax: 'titular de la reserva',
		name: 'Nombre',
		email: 'Email',
		phone: 'Teléfono',
		country: 'País',
		specialRequest: 'Solicitación especial',
		continue: 'CONTINUE',
		resume: 'RESUMEN DE RESERVA',
		guests: 'Huéspedes',
		book: 'RESERVE AQUÍ',
		searchAgain: 'BUSCAR DE NUEVO',
	},
	destinationInfo:{
		title:'INFORMACIÓN DE LA CIUDAD'
	},
	flightReservation: {
		flightReservationTitle: 'COMPRAR PASSAGENS AÉREAS',
		departureDate: 'Data da Partida',
		returnDate: 'Data do Retorno',
		adults: 'Adultos',
		children: 'Crianças',
		age: (n) => n === 1 ? `${n} ano` : `${n} anos`,
		babies: 'Bebês',
		childrenAges: 'Preencha as idades das Crianças',
		origin: 'Origen',
		destination: 'Destino',
		originPlaceholder: 'Digite sua origen',
		destinationPlaceholder: 'Digite su destino',
		continueButton: 'CONTINUE',
	},
	flightRequestOffline: {
		title: 'RESERVA DE VUELO',
		description: 'Blumar ha negociado excelentes tarifas para vuelos dentro de Brasil para todos los participantes',
		with: ' con ',
		discount: 'DESCUENTOS DE HASTA EL  ',
		formTitle: 'Formulario de reserva de aerolínea',
		descriptionForm: 'Luego de llenar este formulario recibirás un email con otras opciones de vuelos con valor y forma de pago.',
		personalDetails: 'Detalles personales',
		fullName: 'NOMBRE COMPLETO',
		email: 'E-MAIL',
		phone: 'TELÉFONO',
		departureAirport: 'AEROPUERTO DE ORIGEN',
		class: 'Classe',
		departureDate: 'FECHA DE SALIDA',
		returnDate: 'FECHA DE REGRESO',
		period: 'PERÍODO',
		mourning: 'Luto',
		afternoon: 'Tarde',
		evening: 'Noche',
		originPlaceholder: 'Digite sua origen',
		send: 'ENVIAR',
		invalidDate: '¡Error! La fecha de salida no puede ser posterior a la fecha de regreso.',
		conclusion: {
			success: {
				title: '¡Éxito!',
				message: 'Solicitud enviada con éxito'
			},
			fail: {
				title: '¡Error al enviar la solicitud!',
				message: '¡No se pudo enviar su solicitud! ¡Inténtalo de nuevo más tarde!'
			}
		},
		wait: 'Esperar'
	},
	eventPromoterWebsite:{
		accessWebsite:'Acceda al sitio web del evento:',
		notFounded : 'Sitio no encontrado'
	},
	transferReservation:{
		title:'RESERVA DE TRANSLADO',
		searchTitle:'BUSCA DE TRANSLADO',
		resume: 'RESUMEN DE RESERVA',
		search: 'Buscar',
		searchAgain: 'Buscar de nuevo',
		wait: 'Buscando...',
		responsible: 'Información del responsable de la reserva',
		paxNumber: 'Nº de Passajeros',
		date: 'Fecha',
		fullName: 'Nombre Completo',
		name:'Nombre',
		email:'E-mail',
		country:'País',
		result: 'Resultado',
		noResult: 'Ningún resultado encontrado',
		resultTitle: 'Resultados de traslados disponibles',
		detail:{
			origin:'Origen',
			destination:'Destino',
			title: 'Detalle de la reserva',
			pax: 'Passajero',
			birthdate: 'Fecha de nascimento',
			hour: 'Hora',
			flightCompany: 'Compañía Aérea ',
			flightNumber: 'Número del vuelo',
			observation: 'Nota',
			price: 'Total',
			pricePerPerson: 'Precio por persona',
			select: 'Seleccionar',
			close: 'Cerrar',
			add: 'Agregar',
			remove: 'Eliminar transfer',
			addAnotherTransfer: 'Agregar otro transfer'
		},
		changeReservation: 'Cambiar Reserva',
	},
	hotelPrices: {
		breakfastIncluded: 'Desayuno incluido',
		breakfastNotIncluded: 'Desayuno no incluido',
		hotelInfo: 'Información del hotel',
		book: 'Reservar',
		soldOut: 'Esgotado',
		location: 'Ubicación',
		eventDistance: 'Distancia del evento:'
	},
	flightReservationCard: {
		origin: 'Origen',
		destination: 'Destino',
		checkinDate: 'Fecha de llegada',
		checkoutDate: 'Fecha de salida',
		adults: 'Adultos',
		kids: 'Niñas',
		babies: 'Bebés',
		bookHere: 'RESERVA AQUÍ'
	},
	visaAndVaccine: {
		title: 'Visto y Vacuna',
		vaccine: 'Vacuna: ',
		url: 'https://www.visitbrasil.com/es/informacion-esencial/salud.html',
		vaccineInfo: 'Para averiguar si necesita una visa de turista para viajar a Brasil, ',
		click: 'clique aqui.',
		vaccineMoreInfo: 'Esta información puede ser alterada por el gobierno brasileño, por lo tanto, antes de viajar, sugerimos busque información actualizada en la agencia gubernamental correspondiente de su país.',
	},
	aboutBrazil: {
		title: 'Informaciones generales',
		menu: {
			health: 'Salud',
			money: 'Dinero',
			time: 'Horario',
			electricity: 'Corriente eléctrica',
			language: 'Idioma',
			climate: 'Clima',
			tipping: 'Gratificaciones',
			taxes: 'Tasas',
			brazillianFoodAndDrinks: 'Comidas y bebidas',
			clothing: 'Vestuario',
			generalSecurity: 'Seguridad',
			beaches: 'Playas'
		},
		content: [
			{
				menu: 'Salud',
				content: 'No hay exigencias obligatorias para entrar al Brasil. Se aconseja tomar precauciones contra la fiebre amarilla, polio, tifus y malaria. Sugerimos que usted entre en contacto con el Consulado del Brasil más próximo para obtener informaciones actualizadas. Es recomendado que usted esté cubierto por un seguro de salud amplio. Atención: si usted pretende entrar al Brasil desde Perú, Ecuador o Colombia, deberá presentar junto con el pasaporte un certificado actualizado de vacunación contra la fiebre amarilla. Dieta local: se aconseja tomar precauciones contra indisposiciones intestinales mientras se adapta al cambio de dieta. Evite comer y beber productos ofrecidos a la venta por ambulantes y restaurantes con prácticas dudosas de higiene o refrigeración. No se recomienda tomar agua de la canilla, especialmente en áreas rurales, debido a alguna probable contaminación. Limite su consumo de agua a productos embotellados, mismo con el tratamiento que el agua recibe en las grandes ciudades, porque los productos químicos utilizados para la potabilización pueden ser diferentes de los que su organismo está acostumbrado. Insistimos en recomendar el uso de agua mineral para beber. Deben evitarse: pescado crudo, frutos del mar, refrescos, cubos de hielo, helado, quesos frescos, yogurt, o cualquier producto vendido por ambulantes.',
			},
			{
				menu: 'Dinero',
				content: 'La moneda brasilera es el REAL. Cien centavos = 1 real. Los billetes están en denominaciones de 100,50, 10, 5, 2 e 1; las monedas en: 1,00 real; 50 centésimos (centavos), 25 centésimos, 10 centésimos, 5 centésimos e 1 centésimo. Todas las casas de cambio aceptan cheques de viaje. En general, se aceptan para el cambio una gran variedad de monedas extranjeras, así mismo recomendamos que el visitante traiga dólares americanos y/o cheques de viaje en esta misma moneda, debido a que es más fácil de cambiar que cualquier otra. En algunos hoteles y restaurantes, usted podrá beneficiarse con un descuento de hasta un 15% al pagar su cuenta en dinero extranjero o cheques de viaje. Subsiste el mercado negro de cambio, por eso recomendamos seriamente que usted ignore a cualquier persona que se aproxime pretendiendo saber si usted quiere cambiar dinero. Tarjetas de crédito Access/Mastercard, American Express, Diners Club y Visa se aceptan en la mayoría de los hoteles, tiendas y restaurantes. Bancos: Horario de servicio en Rio de Janeiro: de lunes a viernes de 10 a 16h,.',
			},
			{
				menu: 'Horario',
				content: 'El territorio brasileño abarca varios husos horarios. Con respecto al GMT, la hora oficial de Brasilia, seguida también de Rio de Janeiro y São Paulo es tres horas más temprano (2 horas más temprano en el verano).',
			},
			{
				menu: 'Corriente eléctrica',
				content: 'La corriente eléctrica en Brasil es 220 volts, excepto en los estados de São Paulo, Rio de Janeiro y Pernambuco, donde es 110 volts. La única excepción en Rio de Janeiro es el Hotel Intercontinental, con 220 volts.',
			},
			{
				menu: 'Idioma',
				content: 'El idioma oficial es el portugués. El idioma inglés también es hablado, sobre todo en las principales ciudades, pero el idioma más próximo del portugués es el español con el cual usted también podrá ser entendido.',
			},
			{
				menu: 'Clima',
				content: 'El clima varia desde la “catinga” árida del interior hasta la impenetrable selva amazónica, al norte, pasando por las playas tropicales del Atlántico, al este del país. El clima en el sur es más templado. Las estaciones de lluvia son: de enero a abril en el norte (promedio de días de lluvia: 22); de abril a julio en el nordeste (promedio de días de lluvia: 14); de diciembre a marzo en la región entre Rio de Janeiro y São Paulo (promedio de días de lluvia: 10).',
			},
			{
				menu: 'Gratificaciones',
				content: 'La grande mayoría de los restaurantes y bares incluyen en la cuenta el 10% correspondiente al servicio. Lugares mas sofisticados pueden llegar a cobrar un incremento de hasta el 15%. Si el servicio no llega a estar incluido, deberá haber un aviso sellado en la cuenta. Las taxis no esperan una gratificación, pero es común redondear la tarifa para arriba. Dependiendo de la época es posible que el valor que se ve en el taxímetro no corresponda al valor exacto debido. Verifique si hay una planilla adherida al vidrio trasero del coche. Allí podrá corroborar el monto exacto.',
			},
			{
				menu: 'Tasas',
				content: 'La tasa de embarque para vuelos internacionales gira en torno de R$ 89,00. Para vuelos domésticos la tasa va de R$ 7,20 a R$ 9,20. Todos los hoteles cobran una tasa turistica destinada al ayuntamiento en el valor de US$ 1,00 por día por apartamento. Todas estas tasas pueden ser pagas en R$ o US$, y deben ser abonadas en el local.',
			},
			{
				menu: 'Comidas y bebidas',
				content: 'Los platos más comunes llevan diversas carnes, arroz y porotos negros (feijão preto). Restaurantes ofrecen buffets de carnes a la parrilla y otros platos. La cocina regional brasileña es ricamente variada e incluye manjares como el Vatapá (ingredientes: camarones, aceite de pescado, leche de coco, pan y arroz) y Sarapatel (ingredientes: menudos de cerdo, tomate, morrón, cebolla y condimentos). En Rio Grande del Sur, el asado impera como plato típico (carne a las brasas, salsa campaña: con tomate, cebolla, aceite y vinagre). De la Amazonia viene el Tacacá (sopa espesa con camarones y ajo). Hay innúmeras variedades de bebidas alcohólicas disponibles en el mercado, incluyendo excelentes cervezas: Antártica, Brahma, Cerpa, Skol. El aguardiente más popular es la caña (cachaça), ingrediente principal de la Caipirinha, hecha con limón en cubos, hielo y azúcar o edulcorante. No hay restricciones en cuanto a horarios para servir bebidas alcohólicas. Entre los refrescos, se encuentran el Guaraná, hecho de la semilla de la planta del mismo nombre. Usted podrá encontrar también una infinita variedad de jugos de frutas, incluyendo algunos que contienen alta concentración de vitaminas y de los cuales usted probablemente nunca ha oído hablar. El café se acostumbra a servir fuerte y azucarado. Si usted prefiere evitar azúcar, pida su jugo o café con edulcorante o sin azúcar.',
			},
			{
				menu: 'Vestuario',
				content: 'El clima en Brasil va de tropical al norte a templado en el sur. En todo el país, la costumbre es vestirse informalmente. Durante el día, lo ideal es usar camisas leves de algodón, shorts vestidos y pantalones leves. Para salir de noche la gente acostumbra a vestirse con camisa de manga larga, pantalones leves y zapatos de cuero. En Brasil difícilmente usted va a usar chaqueta y corbata. En invierno (junio/julio), es recomendable traer un abrigo, debido a que la temperatura puede disminuir bastante en el sur del país.',
			},
			{
				menu: 'Seguridad',
				contentHtml: `
					<span>
						¡Bienvenido a Brasil! Como en todas las grandes ciudades del mundo, es importante estar atento y tomar algunas
						precauciones básicas durante tu viaje. Con unos sencillos cuidados, podrás disfrutar al máximo de tu experiencia y
						centrarte en lo que realmente importa: vivir momentos inolvidables en nuestro país.</span>
					<br><br>
					<span><b>Pautas esenciales para tu seguridad y confort</b></span>
					<br>
					<ul>
						<li><span><b>Frecuenta zonas recomendadas</b> Prioriza lugares como el centro de conferencias, los principales hoteles
								y los puntos turísticos más emblemáticos, como los barrios de Barra da Tijuca, Leblon, Ipanema y Copacabana. No
								dejes de visitar el Corcovado (Cristo Redentor) y el Pan de Azúcar, áreas muy concurridas por turistas y
								habitualmente patrulladas, lo que garantiza mayor tranquilidad.</span></li>
						<li><span><b>Sé discreto</b> Al igual que en otras grandes metrópolis, te recomendamos mantener tus objetos personales
								—como el móvil, las joyas o la cámara— de forma discreta mientras caminas por la ciudad. Así reducirás riesgos y
								disfrutarás de mayor serenidad durante tus paseos.</span></li>
						<li><span><b>Desplazamientos nocturnos</b> Siempre que sea posible, evita caminar solo de noche. Si tienes previsto
								salir, procura hacerlo en compañía y, si es necesario, utiliza aplicaciones de transporte o taxis de confianza,
								que están ampliamente disponibles en la región.</span></li>
					</ul>
					<span><b>Tu experiencia en Río de Janeiro</b></span>
					<br><br>
					<span>Cada año, miles de turistas internacionales visitan Río de Janeiro por motivos académicos, culturales o de
						negocios, y se marchan con recuerdos inolvidables. Con pequeñas precauciones, tu experiencia en la "Ciudad
						Maravillosa" no solo será segura, sino también enriquecedora, llena de oportunidades para aprender, conectar y
						descubrir lo mejor de Brasil.</span>
					<br><br>
					<span>Te deseamos una estancia inolvidable y esperamos que aproveches al máximo todo lo que nuestro país tiene para
						ofrecerte. Estamos a tu disposición para ayudarte en lo que necesites.</span>
					<style>
						ul {
							display: block;
							list-style-type: disc;
							margin-block-start: 1em;
							margin-block-end: 1em;
							padding-inline-start: 40px;
							unicode-bidi: isolate;
						}
					</style>
				`,
			},
			{
				menu: 'Playas',
				content: 'Una parte significativa de la cultura brasileña y del ocio de los brasileños gira en torno a la playa. Las playas pueden ser lugares muy divertidos y relajantes. No obstante, recuerde lo siguiente al ir para la playa: dentro y alrededor de las grandes ciudades, las playas suelen estar bastante llenas de gente, y por eso los consejos sobre seguridad dados anteriormente deben ser considerados seriamente. Es recomendable que no vaya a la playa después que anochece; lleve una toalla o estera de playa pues hay bastantes insectos en la arena. No olvide que el sol en Brasil puede incidir más directamente y ser más fuerte que en Europa, por eso debe tomar las debidas precauciones. En determinadas áreas, en Rio de Janeiro sobre todo, existen corrientes marinas peligrosas. Sabiendo esto, permanezca próximo a otros bañistas y obedezca la señalización indicada por las banderas: roja – peligro, no es aconsejable entrar al mar; amarilla: el mar está apto para baño pero no para nadar; verde: el mar está apto para bañarse y nadar.'
			}
		]
	},
	hotelInfo:{
		starRating: 'estrellas',
		description: 'Descripción',
		galleryTitle: 'Galería de fotos',
		captionFallback: 'Leyenda',
		closeGallery: 'Cerrar galería',
		previewGalleryLabel: 'Galería del hotel',
		morePhotos: count => `Más ${count} fotos`,
	},
  endingBankTicketReservation: {
    endingReservationMessage: {
      title: "Su pedido fue recebido con éxito.",
      text: "Duspués del pagamiento del boleto su reserva estará confirmada. Em caso de que el pagamiento no sea identificado el pedido será automáticamente cancelado.",
			viewBankTicketButton: 'Ver Boleto',
    }
  },
  conclusionBankTicketModal: {
    title: "Su pedido fue recebido con éxito.",
    text: "Duspués del pagamiento del boleto su reserva estará confirmada. Em caso de que el pagamiento no sea identificado el pedido será automáticamente cancelado.",
  },
	conclusionModal: {
		success: {
			title: 'Reserva realizada con éxito.',
			message: 'Le enviaremos un correo electrónico con los detalles de su reserva en breve.'
		},
		fail: {
			title: 'Reserva no realizada.',
			message: 'Hubo un problema al completar la reserva, inténtalo de nuevo más tarde.'
		}
	},
	clientTable: {
		id: 'Id',
		date: 'Fecha',
		client: 'Cliente',
		description: 'Descripción',
		status: 'Estado',
		informationUnavailable: 'Información no disponible'
	},
	conclusionErroClientFiles: {
		title: '¡Error!',
		message: 'Error al recuperar los archivos del cliente.'
	},
	resumeTableHeaderLabels: {
		name: 'Eventos en ',
		start: 'De',
		end: 'A',
		local: 'Local'
	},
	resumeSubtitle: {
		title: 'CURRÍCULUM',
		text: 'Realizamos congresos y eventos hace más de 30 años en diferentes segmentos y somos referencia en el mercado. Con operaciones y desplazamiento de equipos en todo el país, nuestra empresa ya realizó más de 700 eventos, en 24 ciudades brasileñas distribuidas en 12 estados, más el Distrito Federal.'
	},
	transferSection: {
		text: 'Aproveche la comodidad de las opciones de traslado que Blumar Congressos e Eventos, la agencia oficial del {*}, ofrece a los congresistas. Reserva ahora tu traslado al hotel, recinto o aeropuerto. Aceptamos reservas para grupos o individuales.'
	},
	localTour: {
		title: 'Tours Locales en',
		selectText: 'ELIJA LA CIUDAD PARA VER LOS TOURS:',
		selectOption: 'Quiero reservar',
		description: 'Para los momentos de ocio de los participantes de eventos y para sus acompañantes, ofrecemos una selección especial de tours por la ciudad en que será efectuado el evento. Realizamos también programas especiales de acuerdo con el perfil del evento e intereses especiales de los participantes.',
		priceText: 'Precio',
		form: {
			title: 'Haz tu pedido',
			hotel:'Hotel',
			name:'Nombre',
			email:'Email',
			country:'País',
			date:'Data',
			message:'Observación',
			qtdPassenger:'Número de pasajeros',
			namePassenger:'Nombre del pasajero',
			button: 'Solicitar',

			success: {
				title: 'Tour local solicitado con éxito',
				message: 'En breve nos pondremos en contacto contigo para proceder con la reserva.'
			},
			fail: {
				title: 'Error al reservar Tour Local',
				message: 'Hubo un problema al buscar Tours locales. Vuelva a intentarlo más tarde.'
			}
		},
		fail: {
			title: 'Error al buscar Tours Locales',
			message: 'Hubo un problema al buscar Tours locales. Vuelva a intentarlo más tarde.'
		}
	},
	invalidPaymentMessage: {
		bankTicket: {
			title: 'ESTIMADO CLIENTE',
			text: 'Hubo un error al emitir el ticket.'
		},
		creditCard: {
			title: 'ESTIMADO CLIENTE',
			text: 'Pago no autorizado con tarjeta. Le pedimos que se ponga en contacto con el emisor de su tarjeta, ya que es posible que los bloqueos de seguridad hayan impedido el cargo. Seguro de su comprensión, BLUMAR TURISMO.'
		}
	},
	cancelConfirmationPolicy: {
		title: 'CONFIRMACIÓN Y CANCELACIÓN',
		description: (value) => `Al hacer clic en el botón "Acepto", declaro que acepto que la cantidad de ${value} relacionada con mi solicitud de reserva se debite inmediatamente de mi tarjeta de crédito, y acepto las condiciones generales y la política de cancelación y reembolso de Blumar Turismo como a continuación:`,
		bankticketDescription: 'Ao clicar no botão "Concordo", declaro que concordo com as condições gerais e política de cancelamento e reembolso da Blumar Turismo conforme abaixo:',
		firstCondition: 'Las cancelaciones deben hacerse por escrito: eventos@blumar.com.br',
		termsConfirmation: 'He leído y estoy de acuerdo con los términos anteriores.',
	},
	privacyPolicy: {
		htmlContent: `
			<div class="privacy-policy-title">
				<span>Política de Privacidad de Blumar</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p class="content-text">Esta Política de Privacidad describe las prácticas de BLUMAR ("Blumar") con respecto a los datos recopilados a través del sitio web www.eventos.blumar.com.br ("Sitio"), de acuerdo con las leyes aplicables.</p>
				<p class="content-text">Esta política se aplica a los datos que identifican a los miembros, suscriptores, clientes o visitantes ("Usuario") individualmente ("Datos Personales") y otros datos proporcionados por el Usuario o recopilados durante el uso del Sitio. En todos los casos, Blumar cumple con toda la legislación brasileña aplicable a la protección de datos.</p>
				<p>1. CONDICIONES GENERALES</p>
				<p class="content-text">1.1. Todos los datos de los Usuarios que utilicen el Sitio serán tratados de acuerdo con la Ley Nº 13.709, de 14 de agosto de 2020 (Ley General de Protección de Datos). </p>
				<p class="content-text">1.2. Al aceptar esta Política de Privacidad, el Usuario expresa su consentimiento para la recopilación y el procesamiento de sus datos personales por parte de Blumar, incluidos su nombre, correo electrónico, número de teléfono y/o móvil, dirección, fecha de nacimiento y/o otros.</p>
				<p class="content-text">1.3. Al aceptar esta Política de Privacidad, el Usuario expresa su aceptación total y sin reservas para todos los efectos legales. Así, declara que ha leído cuidadosamente y completamente esta Política de Privacidad. Si el Usuario no está de acuerdo con alguno de los términos y reglas aquí establecidos, no debe acceder y/o utilizar el contenido. </p>
				<p class="content-text">1.4. Blumar se reserva el derecho de modificar este acuerdo, informando previamente a los Usuarios y garantizándoles el derecho a retirar su consentimiento para el procesamiento de sus datos si no están de acuerdo con los cambios.</p>
				<p>2. DATOS RECOPILADOS</p>
				<p class="content-text">2.1. Los datos se recopilan cuando el Usuario los introduce o envía voluntariamente al acceder al Sitio. </p>
				<p class="content-text">2.2. Información considerada como Datos Personales identificables que recopilamos de la navegación del Usuario en el Sitio:</p>
				- registros<br>
				- cookies, a través de la herramienta Google Analytics, que recopila de forma anónima y con fines analíticos, los siguientes datos: <br>
				a) idioma;<br>
				b) país y ciudad; <br>
				c) navegador, sistema operativo y proveedor de servicios;<br>
				d) resolución de pantalla, tipo de dispositivo (escritorio o móvil), modelo de dispositivo móvil; y <br>
				e) página que el usuario navega dentro del sitio, si está en el sitio en ese momento, cómo accedió al Sitio (si fue a través de un motor de búsqueda o directamente a través de la URL del sitio), término de búsqueda utilizado en el Sitio, tiempo en la página del Sitio. <br>
				<p class="content-text">2.3. El USUARIO puede obtener más información sobre Google Analytics en "Cómo utiliza Google los datos cuando el usuario utiliza sitios web o aplicaciones de nuestros socios", ubicado en . </p>
				<p class="content-text">2.4. Los datos recopilados por Google a través de Google Analytics, así como cualquier uso o procesamiento realizado debido a dicha recopilación, serán responsabilidad exclusiva de Google, eximiendo a Blumar de cualquier responsabilidad derivada de ello. </p>
				<p class="content-text">2.5. Si el Usuario no está de acuerdo con la recopilación de datos por parte de Google Analytics, puede deshabilitarla a través del complemento del navegador, disponible en el enlace https://tools.google.com/dlpage/gaoptout?hl=es. </p>
				<p class="content-text">2.6. Es deber del Usuario proporcionar información correcta y actualizada. No somos responsables de la exactitud, veracidad o falta de ella en la información proporcionada por el Usuario.</p>
				<p class="content-text">2.7. Nos asociamos con Microsoft Clarity y Microsoft Advertising para capturar cómo usa e interactúa con nuestro sitio a través de métricas de comportamiento, mapas de calor y reproducción de sesiones para mejorar y comercializar nuestros productos/servicios. Los datos de uso del sitio web se capturan utilizando cookies propias y de terceros y otras tecnologías de seguimiento para determinar la popularidad de los productos/servicios y actividades en línea. Además, utilizamos esta información para la optimización del sitio web, fines de fraude/seguridad y publicidad. Para obtener más información sobre cómo Microsoft recopila y usa sus datos, visite la Declaración de Privacidad de Microsoft (https://privacy.microsoft.com/es-ES/privacystatement).</p>
				<p>3. ENLACES A SITIOS DE TERCEROS</p>
				<p class="content-text">3.1. Al navegar por el Sitio, el Usuario puede ser llevado, a través de un hipervínculo, a contenido o servicios o a otros portales o plataformas, que pueden recopilar sus datos y tener su propia política de privacidad.</p>
				<p class="content-text">3.2. Los hipervínculos externos no constituyen un respaldo por parte de Blumar de los sitios/entornos vinculados o la información, productos o servicios contenidos en ellos. Estos hipervínculos se proporcionan solo para su referencia.</p>
				<p class="content-text">3.3. Blumar no tendrá ninguna responsabilidad por el material contenido en estos sitios ni por ninguna asociación con sus operadores. </p>
				<p class="content-text">3.4. Blumar no controla estos sitios y no es responsable de su contenido ni del uso que el Usuario haga de ellos.</p>
				<p>4. CÓMO SE UTILIZARÁN LAS INFORMACIONES</p>
				<p class="content-text">4.1. Blumar puede utilizar los datos que se han recopilado y los registros de actividades en los Sitios para los siguientes fines: </p>
				i. prestación de servicios contratados, por Blumar o terceros;<br>
				ii. contacto con clientes potenciales; <br>
				iii. análisis estadístico de resultados;<br>
				iv. promoción de servicios ofrecidos; <br>
				v. mejora de servicios en el sitio;<br>
				vi. mejora del contenido informado;<br>
				vii. defensa de intereses en procesos administrativos y judiciales; y/o<br>
				viii. cumplimiento de una orden judicial o solicitud administrativa.<br>
				<p class="content-text">4.2. El consentimiento con respecto a la recopilación y el procesamiento de datos proporcionados por el Usuario se otorga libre, expresa, individual, clara, específica y legítimamente.</p>
				<p class="content-text">4.3. Si el Usuario no otorga su consentimiento para la preparación de la prueba, los servicios no estarán disponibles para él.</p>
				<p class="content-text">4.4. Si el Usuario no otorga su consentimiento para los fines opcionales, relacionados con el envío de información sobre hoteles, tours, ofertas y promociones, entre otros materiales informativos, la prestación de servicios continuará realizándose regularmente.</p>
				<p class="content-text">4.5. El Usuario reconoce y acepta que sus Datos Personales recopilados por Blumar pueden ser compartidos con proveedores de servicios contratados por el usuario, como hoteles, aerolíneas y otros terceros contratados.</p>
				<p class="content-text">4.6. Los datos recopilados y las actividades registradas también pueden ser compartidos con autoridades judiciales, administrativas o gubernamentales, siempre que haya una solicitud, requisición u orden judicial.</p>
				<p class="content-text">4.7. Internamente, los datos de nuestros Usuarios son accesibles solo por profesionales debidamente autorizados, respetando los principios de proporcionalidad, necesidad y relevancia para nuestros objetivos, además del compromiso de confidencialidad y preservación de la privacidad en los términos de esta Política de Privacidad.</p>
				<p>5. ALMACENAMIENTO DE DATOS Y REGISTROS</p>
				<p class="content-text">5.1. Los datos y registros de actividades recopilados se almacenarán en un entorno seguro y controlado por un período mínimo de 6 (seis) meses, bajo los términos de la Ley 12.965, de 23 de abril de 2014 (Marco Civil de Internet), considerando el estado del arte disponible.</p>
				<p class="content-text">5.2. Los datos se eliminarán antes de este período si así lo solicita el Usuario, a través del canal de atención al cliente indicado en el ítem 6.1. </p>
				<p class="content-text">5.3. Con fines de auditoría, seguridad o control de fraudes, o cuando lo requiera la ley o una decisión judicial, Blumar puede mantener el historial de registro de los datos de los Usuarios por un período más largo, después del cual se eliminarán utilizando métodos de disposición segura.</p>
				<p class="content-text">5.4. Los datos recopilados se almacenan en servidores propios de Blumar, ubicados en Brasil, así como en la nube, lo que puede implicar, en esta situación, la transferencia o procesamiento de datos fuera de Brasil, en terceros países.</p>
				<p>6. VISUALIZACIÓN, RECTIFICACIÓN Y ELIMINACIÓN DE DATOS</p>
				<p class="content-text">6.1. El Usuario puede solicitar la visualización o rectificación de sus Datos Personales a través del correo electrónico viajepelobrasil@blumar.com.br.</p>
				<p class="content-text">6.2. A través de la misma herramienta de atención al cliente, el Usuario puede: a) Solicitar la limitación del acceso y uso de sus Datos Personales; b) Expresar su oposición al uso de sus Datos Personales; y c) Solicitar la eliminación de sus Datos Personales recopilados y registrados por Blumar.</p>
				<p class="content-text">6.3. Si el Usuario revoca su consentimiento para los fines fundamentales del Sitio, los servicios y características del mismo pueden volverse inaccesibles para ese Usuario.</p>
				<p>7. PROPIEDAD INTELECTUAL</p>
				<p class="content-text">7.1. Cada uno de los textos, fotografías, diseños, planes, imágenes, videos, ilustraciones, íconos, tecnologías, enlaces y otros contenidos audiovisuales o sonoros, incluidos el software del Sitio, los diseños gráficos y los códigos fuente, son propiedad exclusiva de Blumar o de terceros que han autorizado su uso en el Sitio, estando protegidos por leyes y tratados internacionales, quedando prohibida su copia, reproducción o cualquier otro tipo de uso, los infractores siendo objeto de las correspondientes sanciones civiles y penales, bajo los términos de las Leyes 9.279/96, 9.609/98 y 9.610/98.</p>
				<p class="content-text">7.2. Las marcas, nombres comerciales o logotipos de cualquier tipo presentados a través del Sitio son propiedad de Blumar o de terceros que han permitido su uso, de modo que el uso del Sitio no constituye autorización para que el Usuario cite dichas marcas, nombres comerciales y logotipos.</p>
				<p>8. LEY APLICABLE Y JURISDICCIÓN</p>
				<p class="content-text">8.1. Esta Política de Privacidad y la relación derivada de las acciones comprendidas en ella, así como cualquier disputa que surja como resultado de la misma, se regirán exclusivamente por la legislación brasileña.</p>
				<p class="content-text">8.2. Se elige el Tribunal Central del Distrito Capital del Estado de Río de Janeiro para resolver cualquier cuestión relacionada con este documento, renunciando las partes a cualquier otro, por privilegiado que sea o pueda llegar a ser.</p>
			</div>

			<div class="privacy-policy-title">
				<span>POLÍTICA DE COOKIES</span><hr>
			</div>
			<div class="privacy-policy-text">
				<p>Qué son las Cookies</p>
				<p class="content-text">Las Cookies son pequeños archivos de texto que se colocan en su dispositivo electrónico cuando visita nuestro sitio web. Estos pequeños archivos sirven para reconocer, rastrear y almacenar su navegación como usuario de Internet.</p>
				<p class="content-text">Las Cookies se utilizan ampliamente para asegurar el funcionamiento más eficiente del sitio web y para observar los hábitos de visita.</p>
				<p class="content-text">Para mejorar su experiencia, utilizamos Cookies combinadas con otras tecnologías similares.</p>
				<p>Por qué utilizamos Cookies</p>
				<p class="content-text">Utilizamos Cookies por varias razones. Algunas son necesarias por razones técnicas, para asegurar el funcionamiento adecuado del sitio web.</p>
				<p class="content-text">Otras Cookies ofrecen una mejor experiencia en el sitio web debido a la memorización de algunas de sus actividades (incluyendo a través de nuestros plugins, widgets y contenido incrustado), además de las Cookies que permiten un mejor análisis de la navegación y que muestran publicidad más relevante.</p>
				<p>Qué tipos de Cookies</p>
				<p class="content-text">Las Cookies pueden ser:</p>
				<p class="content-text">Cookies Propias: son Cookies establecidas por nosotros, o en nuestro nombre, y utilizadas en nuestro sitio web;</p>
				<p class="content-text">Cookies de Terceros: son Cookies establecidas por terceros, utilizadas dentro o fuera de nuestro sitio web, que pueden tener acceso a los datos en su dispositivo pero no pueden recopilar su nombre, información de contacto u otra información personal a menos que usted decida divulgar sus datos.</p>
				<p class="content-text">Cookies Esenciales o Estrictamente Necesarias: Estas Cookies son necesarias para el sitio web y no se pueden desactivar en nuestros sistemas. Por lo general, se establecen en respuesta a acciones que corresponden a una solicitud de servicios, como configurar sus preferencias de privacidad, iniciar sesión o completar formularios. Puede configurar su navegador para bloquear o alertarle sobre estas Cookies, pero algunas partes del sitio web no funcionarán correctamente.</p>
				<p class="content-text">Cookies de Rendimiento: Estas Cookies nos permiten contar visitas y fuentes de tráfico, para que podamos medir y mejorar el rendimiento de nuestro sitio web. Nos ayudan a saber qué páginas son las más y menos populares y ver cómo los visitantes se mueven por el sitio web.</p>
				<p class="content-text">Cookies de Funcionalidad: Estas Cookies permiten que el sitio web proporcione una funcionalidad y personalización mejoradas. Pueden ser establecidas por nosotros (Propias) o por proveedores externos (Terceros), cuyos servicios hemos agregado a nuestras páginas.</p>
				<p class="content-text">Cookies de Publicidad: Estas Cookies pueden ser establecidas a través del sitio web por nuestros socios publicitarios. Pueden ser utilizadas por estas empresas para analizar y/o construir un perfil sobre sus intereses y optimizar anuncios relevantes en otros sitios web.</p>
				<p class="content-text">Cookies de Redes Sociales: Estas Cookies son establecidas por una variedad de servicios de redes sociales que hemos agregado a nuestro sitio web para permitirle compartir nuestro contenido con sus amigos y conocidos. Son capaces de rastrear su navegación en otros sitios web y crear un perfil sobre sus intereses.</p>
				<p>Cómo cambiar o bloquear las Cookies</p>
				<p class="content-text">La mayoría de los navegadores están configurados para aceptar cookies automáticamente. Sin embargo, puede cambiar la configuración para bloquear cookies o alertarle cuando una cookie está siendo enviada a su dispositivo. Hay varias formas de gestionar las cookies, y puede crear un bloqueo general para las cookies, bloquear cookies de un sitio específico o incluso bloquear cookies de terceros en relación con un sitio. Bloquear todas las cookies afectará el funcionamiento de su experiencia, ya que no será posible identificar sus preferencias y recomendar contenido y publicidad relevantes.</p>
				<p class="content-text">Consulte las instrucciones de su navegador para obtener más información sobre cómo ajustar o cambiar su configuración, recordando que la configuración deseada debe replicarse en todos los dispositivos utilizados para acceder a los Servicios (como computadoras, teléfonos inteligentes, tabletas).</p>
				<p>Actualizaciones</p>
				<p class="content-text">Podemos actualizar esta Política de Cookies en cualquier momento. Cualquier cambio entrará en vigor a partir de la fecha en que se publiquen, o según lo requiera la ley, y se comunicará debidamente a través de nuestros canales de comunicación del sitio web.</p>
			</div>
		`
	},
	staticPages: {
		companyProfile: {
			title: '¿Quiénes somos?',
			introduction: 'Blumar Turismo es una operadora de turismo con más de 30 años de experiencia y líder en el mercado, contando hoy con clientes activos distribuidos en todos los continentes.',
			segmentsLabel: 'Actuamos en los siguientes sectores:',
			segments: [
				'Turismo Receptivo Internacional',
				'Viajes Corporativos y de Incentivo',
				'Logística de Turismo de Congresos y Eventos',
			],
			operations: 'Con un equipo joven, dinámico y multilingüe, cuidamos de toda la logística de turismo del evento desde su captación hasta la operación y el cierre. Todos los procesos son gestionados y supervisados por profesionales altamente calificados, con amplia experiencia y listos para atender todas las solicitudes. Tenemos como objetivo la excelencia en la calidad de nuestros servicios, priorizando la seriedad y la transparencia en las negociaciones.',
			vision: 'Blumar busca ser una empresa reconocida por sus clientes, proveedores y competidores como la empresa de eventos más creativa y confiable del mercado, permaneciendo entre las líderes en los principales segmentos: Receptivo, Incentivo y Eventos.',
			mission: {
				title: 'Nuestra Misión',
				text: 'Satisfacer las necesidades de los clientes y superar sus expectativas con respecto al ocio, la cultura y los negocios, proporcionando servicios de alojamiento, transporte y acompañamiento de alta calidad.',
			},
			clients: {
				title: 'Número de clientes',
				text: 'Contamos con más de 1.000 clientes activos distribuidos en todos los continentes.',
			},
			differentials: {
				title: 'Diferenciales Blumar',
				items: [
					{
						title: 'Experiencia y conocimiento especializado',
						text: 'Más de 40 años en el sector, con un profundo conocimiento del panorama turístico brasileño y servicios que abarcan todos los aspectos de los viajes en Brasil.',
					},
					{
						title: 'Conocimiento local',
						text: 'Nuestro equipo conoce el destino de primera mano y es capaz de ofrecer productos y experiencias verdaderamente únicos. Nos enorgullece contar con un equipo multinacional y multilingüe que trabaja en todo Brasil.',
					},
					{
						title: 'Productos innovadores',
						text: 'Nunca dejamos de crear. Buscamos estar a la vanguardia del desarrollo de nuevos productos, creando paquetes y experiencias únicas y fuera de lo común.',
					},
					{
						title: 'Tecnología de punta',
						text: 'Una plataforma web avanzada que simplifica el proceso de reserva para los clientes, ofreciendo fácil acceso a los mejores hoteles, tours y servicios disponibles en Brasil.',
					},
					{
						title: 'Gestión y finanzas sólidas',
						text: 'Nuestras credenciales en el mercado son excelentes. Como cliente clave y socio preferente de los principales hoteles de Brasil, podemos ofrecer mayor seguridad para su operación.',
					},
					{
						title: 'Social y ecológicamente responsable',
						text: 'Como empresa, Blumar se esfuerza por apoyar a las comunidades locales en los destinos donde opera, además de minimizar su impacto ambiental.',
					},
				],
			},
			structure: {
				title: 'Estructura del Departamento de Eventos',
				paragraphs: [
					'Nuestro equipo de Eventos está formado por 15 profesionales comprometidos y con experiencia. El primer contacto con el cliente es realizado por el equipo comercial del departamento, que busca comprender sus necesidades y elaborar la propuesta más personalizada posible. En nuestras negociaciones ofrecemos beneficios y diferenciales exclusivos, así como flexibilidad en la elaboración de paquetes, descuentos y formas de pago.',
					'Para cada evento captado, además de un equipo operativo, designamos una coordinadora para el evento de acuerdo con su perfil y experiencia en el segmento.',
					'Entre las principales funciones, brindamos atención personalizada a la comisión organizadora de la entidad y a la empresa organizadora del congreso. Prestamos asesoría a los invitados y ponentes, cuidando de la logística de su viaje, ayudando en la elección de los mejores servicios y respondiendo a sus dudas.',
					'Esta atención se realiza antes del evento y también en el propio lugar donde se celebra. Podemos disponer de un Desk de soporte de Blumar especialmente preparado para satisfacer todas las necesidades de los clientes durante el evento.',
					'Operamos eventos, congresos y simposios de diferentes tamaños en todo el país, tanto nacionales como internacionales y de distintos segmentos. Gracias a la excelente relación comercial que Blumar ha desarrollado con el sector turístico, contamos con socios capacitados y ofrecemos apoyo local y desplazamiento del equipo para cada evento operado.',
				],
			},
		},
		accommodation: {
			title: 'Hospedaje',
			lead: 'Blumar posee acuerdos con hoteles en todo el Brasil. Por el tiempo de mercado y volumen de negocios garantizamos excelentes negociaciones, condiciones y tarifas.',
			items: [
				{
					number: '1',
					title: 'Soporte y asistencia en la elección de los hoteles',
					text: 'Al ser reconocida como Agencia Oficial de Turismo, el equipo analiza el perfil del evento y, junto con la Comisión Organizadora, elije los hoteles que formarán parte de la lista oficial y serán colocados a disposición de los participantes de acuerdo con el perfil del evento.',
				},
				{
					number: '2',
					title: 'Negociación de tarifas especiales',
					text: 'Así como es de su interés encargarse de la organización y realización del congreso, Blumar también se interesa por atraer para el evento el mayor número posible de participantes. Para eso, negociamos tarifas especiales con los hoteles, una variada gama de precios para todos los perfiles de participantes.',
				},
				{
					number: '3',
					title: 'Flexibilidad de elección',
					text: 'Para atender a todos los perfiles de participantes, Blumar ofrece diferentes opciones de hoteles, de diversos precios, categorías e localizaciones, pretendiendo siempre dar mayor satisfacción a nuestros clientes.',
				},
				{
					number: '4',
					title: 'Sistema de administración de reservas',
					text: 'Poseemos un sistema de reservas verdaderamente on-line. A través de este sistema, los clientes pueden realizar sus reservas de forma rápida y segura, obteniendo una confirmación inmediata. Además ofrecemos al cliente final, acceso al informe de reservas efectuadas a través de un login y contraseña.',
				},
			],
		},
		flightBookings: {
			title: 'Pasaje Aéreo',
			intro: [
				'Blumar posee un departamento específico que trata de la negociación, cotización y emisión de los pasajes aéreos de los eventos. El departamento cuenta con un equipo exclusivo de profesionales con experiencia, que están siempre en búsqueda de la mejor oferta para nuestros clientes.',
				'Somos una agencia IATA, realizamos reservas y emisiones de pasajes aéreos en todo el Brasil y el exterior, utilizando el sistema Amadeus, E-TAM y el portal de GOL, Azul, Avianca y Trip. Además ofrecemos para los eventos:',
			],
			items: [
				{
					number: '1',
					title: 'Asesoría en la elección del transporte aéreo oficial',
					text: 'Muchas veces es interesante para un evento establecer un transporte aéreo oficial. Así es posible obtener más beneficios en pasajes y condiciones. En este caso, Blumar con su experiencia de mercado, auxilia y acompaña todo el proceso, desde las propuestas y negociaciones hasta la elección final.',
				},
				{
					number: '2',
					title: 'Negociación de descuentos exclusivos',
					text: 'Por ser una operadora de Turismo y Agencia de Recepción, Blumar posee excelentes contactos comerciales con todas las compañías aéreas. Debido a que somos reconocidos como Agencia Oficial de un evento, negociamos descuentos de hasta un 15% de los valores publicados en las páginas web de las principales compañías aéreas, en los pasajes emitidos para los participantes del evento.',
				},
				{
					number: '3',
					title: 'Emisión de pasajes aéreos para conferencistas e invitados',
					text: 'Contando con un equipo altamente personalizado y especializado en atención VIP al público, Blumar se coloca a disposición de la sociedad o empresa para entrar en contacto con los conferencistas e invitados y ofrecer la mejor opción de pasajes aéreos. Enviamos informes estandarizados para control general de las emisiones con la periodicidad que sea solicitada.',
				},
			],
		},
		transportation: {
			title: 'Transporte',
			lead: 'Ofrecemos los servicios de:',
			items: [
				{
					number: '1',
					title: 'Transfer',
					text: 'Para mayor comodidad de los participantes del evento, ofrecemos la alternativa de reserva de transporte del aeropuerto para el hotel y del hotel para el aeropuerto.',
				},
				{
					number: '2',
					title: 'Shuttle',
					text: 'Muchos eventos colocan a disposición de los participantes un servicio de transporte de los hoteles para el Centro de Convenciones, además de un personal especializado para coordinar este servicio y guías para todos los autobúses. En este caso, Blumar se responsabiliza por negociar los mejores precios y condiciones, elaborar el proyecto y recorridos y actúa siempre con las mejores empresas del mercado, dando mayor seguridad y confort a los participantes.',
				},
				{
					number: '3',
					title: 'Otros',
					text: 'Organizamos también el alquiler de autobús, micro-autobús, van Sprinter, coches de paseo y coches blindados. Negociamos con flotas de taxis especiales y arrendadores de autos para que estén a disposición de los participantes cuando sea solicitado. Blumar Turismo organiza la recepción en el aeropuerto y la atención a los pasajeros con informaciones y providencias para los traslados.',
				},
			],
		},
	},
	eventStamps: {
		BLUMAR_RECOMMENDS: 'Blumar Recomienda',
		SHUTTLE: 'Shuttle',
		SPECIAL_OFFER: 'Oferta especial',
		WALK: 'Walk',
	}
}



// WEBPACK FOOTER //
// ./src/assets/translationSp.js